// import { tokenBridge } from '@contexts/auth/tokenBridge';
import { fetchAuthSession } from 'aws-amplify/auth';
import { type AxiosInstance } from 'axios';

export function setTokens(httpClient: AxiosInstance): void {
  httpClient.interceptors.response.use(success => {
    if (success.data.token) {
      httpClient.defaults.headers.common.Authorization = `Bearer ${success.data.token}`;
    }
    return success;
  });

  httpClient.interceptors.request.use(async _config => {
    try {
      const session = await fetchAuthSession();

      const tokens = session.tokens;
      if (tokens) {
        _config.headers.Authorization = `Bearer ${tokens.accessToken}`;
        _config.headers['x-id-token'] = `Bearer ${tokens.idToken}`;
      }
    } catch (error) {
      // TODO: add sentry catching
      console.log('Error fetching auth session:', error);
    }
    return _config;
  });
}
